import {Input} from 'antd'
import {Rule} from 'antd/lib/form'

import {Button, Form, FormItem} from 'common/components'
import {FIELD_RULES} from 'common/constants'
import {useUpdateProfile} from '..'

interface PasswordChangeFormProps {
  onClose: () => void
}

const confirmPasswordRules: Rule[] = [
  ...FIELD_RULES,
  ({getFieldValue}) => ({
    validator(_, value) {
      return !value || getFieldValue('password') === value
        ? Promise.resolve()
        : Promise.reject('passwords do not match')
    },
  }),
]

export default function PasswordChangeForm({onClose}: PasswordChangeFormProps) {
  const {mutate: updateProfile, isMutating} = useUpdateProfile(onClose)

  const handleFinish = ({confirmPassword, ...values}: any) =>
    updateProfile(values)

  return (
    <Form onFinish={handleFinish}>
      <FormItem name="oldPassword" label="Old password" rules={FIELD_RULES}>
        <Input.Password autoFocus />
      </FormItem>
      <FormItem name="password" label="New password" rules={FIELD_RULES}>
        <Input.Password />
      </FormItem>
      <FormItem
        name="confirmPassword"
        label="Confirm new password"
        rules={confirmPasswordRules}
      >
        <Input.Password />
      </FormItem>
      <Button block htmlType="submit" loading={isMutating}>
        Change password
      </Button>
    </Form>
  )
}
